import React, { useState, lazy } from 'react';
import { MapPin, Phone, Mail, Clock, Send } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission
    console.log('Form submitted:', formData);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <div className="flex flex-col w-full" data-id="element-450">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-wh-teal to-teal-600 py-20" data-id="element-451">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-452">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-453">
            Get in Touch
          </h1>
          <p className="text-xl text-white/90 max-w-2xl mx-auto" data-id="element-454">
            Ready to bring your vision to life? Contact us today for a free
            quote or to discuss your project.
          </p>
        </div>
      </section>

      {/* Contact Form & Info */}
      <section className="py-20 bg-white" data-id="element-455">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-456">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-457">
            {/* Contact Form */}
            <div data-id="element-458">
              <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-459">
                Send Us a Message
              </h2>
              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-460">
                <div data-id="element-461">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-462">
                    Name *
                  </label>
                  <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-wh-pink focus:border-transparent" data-id="element-463" />
                </div>

                <div data-id="element-464">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-465">
                    Email *
                  </label>
                  <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-wh-pink focus:border-transparent" data-id="element-466" />
                </div>

                <div data-id="element-467">
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-468">
                    Phone
                  </label>
                  <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-wh-pink focus:border-transparent" data-id="element-469" />
                </div>

                <div data-id="element-470">
                  <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-471">
                    Company/Organization
                  </label>
                  <input type="text" id="company" name="company" value={formData.company} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-wh-pink focus:border-transparent" data-id="element-472" />
                </div>

                <div data-id="element-473">
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-474">
                    Message *
                  </label>
                  <textarea id="message" name="message" required rows={6} value={formData.message} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-wh-pink focus:border-transparent" data-id="element-475" />
                </div>

                <Button type="submit" variant="primary" size="lg" className="w-full" rightIcon={<Send className="w-5 h-5" data-id="element-477" />} data-id="element-476">
                  Send Message
                </Button>
              </form>
            </div>

            {/* Contact Information */}
            <div data-id="element-478">
              <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-479">
                Contact Information
              </h2>

              <div className="space-y-6 mb-8" data-id="element-480">
                <div className="flex items-start gap-4" data-id="element-481">
                  <div className="flex-shrink-0 w-12 h-12 bg-wh-pink rounded-lg flex items-center justify-center text-white" data-id="element-482">
                    <MapPin className="w-6 h-6" data-id="element-483" />
                  </div>
                  <div data-id="element-484">
                    <h3 className="font-bold text-gray-900 mb-1" data-id="element-485">Address</h3>
                    <p className="text-gray-600" data-id="element-486">
                      4425 West US 20, Suite 1
                      <br data-id="element-487" />
                      LaGrange, Indiana 46761
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-488">
                  <div className="flex-shrink-0 w-12 h-12 bg-wh-teal rounded-lg flex items-center justify-center text-white" data-id="element-489">
                    <Phone className="w-6 h-6" data-id="element-490" />
                  </div>
                  <div data-id="element-491">
                    <h3 className="font-bold text-gray-900 mb-1" data-id="element-492">Phone</h3>
                    <a href="tel:260-463-7373" className="text-gray-600 hover:text-wh-pink transition-colors" data-id="element-493">
                      260-463-7373
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-494">
                  <div className="flex-shrink-0 w-12 h-12 bg-wh-yellow rounded-lg flex items-center justify-center text-gray-900" data-id="element-495">
                    <Mail className="w-6 h-6" data-id="element-496" />
                  </div>
                  <div data-id="element-497">
                    <h3 className="font-bold text-gray-900 mb-1" data-id="element-498">Email</h3>
                    <a href="mailto:wearhaus@wearhaus.net" className="text-gray-600 hover:text-wh-pink transition-colors" data-id="element-499">
                      wearhaus@wearhaus.net
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-500">
                  <div className="flex-shrink-0 w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center text-gray-600" data-id="element-501">
                    <Clock className="w-6 h-6" data-id="element-502" />
                  </div>
                  <div data-id="element-503">
                    <h3 className="font-bold text-gray-900 mb-1" data-id="element-504">
                      Business Hours
                    </h3>
                    <p className="text-gray-600" data-id="element-505">
                      Monday – Friday: 8:00 AM to 4:00 PM EST
                      <br data-id="element-506" />
                      Saturday – Sunday: Closed
                    </p>
                  </div>
                </div>
              </div>

              {/* Map */}
              <div className="rounded-xl overflow-hidden shadow-lg" data-id="element-507">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d381655.02125268657!2d-85.83935475429354!3d41.64105098022174!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88165a302a088877%3A0xf44ce14d635fb135!2sWear%20Haus%20Designs!5e0!3m2!1sen!2sus!4v1768498100010!5m2!1sen!2sus" width="100%" height="300" style={{
                border: 0
              }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Wear Haus Designs Location" data-id="element-508" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
}